var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm.31-10.135H7.04c-.574 0-1.04.465-1.04 1.04 0 .574.466 1.04 1.04 1.04h.345v3.813c0 .574.466 1.04 1.04 1.04.575 0 1.04-.466 1.04-1.04V7.02c0-.638-.517-1.155-1.155-1.155zm-1.615-2.08c0-.766.62-1.387 1.386-1.387.766 0 1.387.62 1.387 1.387 0 .765-.62 1.386-1.387 1.386-.765 0-1.386-.62-1.386-1.386z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.550188e9.svg";
export { ForwardRef as ReactComponent };